import React from 'react';
import { Users, MessageCircle, Image, Trophy } from 'lucide-react';

const CommunityPage = () => {
  return (
    <div className="min-h-screen bg-black">
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 py-16">
        <div className="text-center py-12 mb-12">
          <Users className="w-24 h-24 text-orange-500 mx-auto mb-6" />
          <h1 className="text-4xl font-black text-white mb-4">Community</h1>
          <p className="text-xl text-gray-400 mb-8">
            Connect with creators and fans, share fan art, and discuss your favorite series
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          <div className="bg-gray-900 rounded-lg p-8 text-center border border-gray-800">
            <MessageCircle className="w-12 h-12 text-orange-500 mx-auto mb-4" />
            <h3 className="text-xl font-bold text-white mb-2">Forums</h3>
            <p className="text-gray-400">Join discussions about your favorite comics and novels</p>
          </div>

          <div className="bg-gray-900 rounded-lg p-8 text-center border border-gray-800">
            <Image className="w-12 h-12 text-orange-500 mx-auto mb-4" />
            <h3 className="text-xl font-bold text-white mb-2">Fan Art</h3>
            <p className="text-gray-400">Share and discover amazing fan creations</p>
          </div>

          <div className="bg-gray-900 rounded-lg p-8 text-center border border-gray-800">
            <Trophy className="w-12 h-12 text-orange-500 mx-auto mb-4" />
            <h3 className="text-xl font-bold text-white mb-2">Contests</h3>
            <p className="text-gray-400">Participate in creator challenges and events</p>
          </div>
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-500">
            Community features are currently in development. Stay tuned!
          </p>
        </div>
      </div>
    </div>
  );
};

export default CommunityPage;